module.exports = __webpack_public_path__ + "media/cuk/cuk_car@2x-6c467e18.png";